import { useFlexiblePropertiesEntry } from '../../hooks/useFlexiblePropertiesEntry';

import { useAuth } from '../../components/AuthProvider';
import FlexiblePropertiesPage from '../../containers/FlexiblePropertiesPage';
import PropertiesPage from '../../containers/PropertiesPage';
import { ZRAMPropertiesPage } from '../../containers/ZRAMPropertiesPage';

const PropertiesRoute = () => {
  const { user } = useAuth();
  const { canAccessFlexibleProperties } = useFlexiblePropertiesEntry();

  if (user?.isEnterpriseCustomer) {
    return <ZRAMPropertiesPage />;
  }

  if (canAccessFlexibleProperties) {
    return <FlexiblePropertiesPage />;
  }

  return <PropertiesPage />;
};

export default PropertiesRoute;
